import { event } from 'vue-gtag';
import {
	GA_CATEGORY_TYPE,
	GA_ACTION_TYPE,
} from '../../googleAnalytics/constants';

const state = {
	showFeedBackModal: false,
	expandedMenu: true,
	expandedSmallNav: false,
	expandedSmallSearch: false,
	expandedProfileSelector: false,
	brandBuilder: false,
	brandBuilderNav: false,
	dashboard: false,
	showVideoReviewSpinner: false,
};

const mutations = {
	TOGGLE_EXPANDED_MENU() {
		state.expandedMenu = !state.expandedMenu;
		state.expandedProfileSelector = false;
		if (state.expandedSmallNav) {
			state.expandedSmallNav = false;
		}
		event(
			GA_CATEGORY_TYPE.DESKTOP_TOP_NAVBAR,
			GA_ACTION_TYPE.USER_CLICK,
			'hamburger menu toggled',
			10,
		);
	},

	TOGGLE_EXPANDED_SMALL_NAV() {
		state.expandedSmallNav = !state.expandedSmallNav;
		if (state.expandedSmallNav) {
			state.expandedMenu = true;
		}
		event(
			GA_CATEGORY_TYPE.MOBILE_TOP_NAVBAR,
			GA_ACTION_TYPE.USER_CLICK,
			'hamburger menu toggled',
		);
	},

	CLOSE_EXPANDED_SMALL_NAV() {
		state.expandedSmallNav = false;
	},

	TOGGLE_EXPANDED_SMALL_SEARCH() {
		state.expandedSmallSearch = !state.expandedSmallSearch;
	},

	CLOSE_EXPANDED_SMALL_SEARCH() {
		state.expandedSmallSearch = false;
	},

	TOGGLE_EXPANDED_PROFILE_SELECTOR() {
		state.expandedProfileSelector = !state.expandedProfileSelector;
	},

	TOGGLE_BRAND_BUILDER_NAV() {
		state.brandBuilderNav = !state.brandBuilderNav;
		this.$gtag.event({
			eventCategory: 'global menu in brand builder editor',
			eventAction:
				'desktop menu toggled from large to small in the brand builder editor',
			eventLabel: 'hamburger menu pressed in brand builder editor',
		});
	},

	TOGGLE_BRAND_BUILDER() {
		state.brandBuilder = !state.brandBuilder;
		this.$gtag.event({
			eventCategory: 'brand builder editor',
			eventAction: 'user entered brand builder editor',
			eventLabel: 'menu system changed',
		});
	},

	BRAND_BUILDER_CREATED() {
		state.brandBuilderNav = false;
		state.brandBuilder = true;
		/*
		this.$gtag.event({
			eventCategory: 'brand builder editor',
			eventAction: 'user entered brand builder editor',
			eventLabel: 'menu system changed to editor version',
        });
        */
	},

	BRAND_BUILDER_DESTROYED() {
		state.brandBuilderNav = true;
		state.brandBuilder = false;
		/*
		this.$gtag.event({
			eventCategory: 'brand builder editor',
			eventAction: 'user exited brand builder editor',
			eventLabel: 'menu system changed to normal version',
        });
        */
	},

	DASHBOARD_CREATED() {
		state.dashboard = true;
		state.brandBuilder = false;
	},

	DASHBOARD_DESTROYED() {
		state.dashboard = false;
	},

	TOGGLE_DASHBOARD() {
		state.dashboard = !state.dashboard;
	},

	TOGGLE_FEEDBACK_MODAL(state, payload) {
		if (payload === 'show') {
			state.showFeedBackModal = true;
		} else if (payload === 'hide') {
			state.showFeedBackModal = false;
		} else {
			state.showFeedBackModal = !state.showFeedBackModal;
		}
	},
	SET_VIDEO_REVIEW_SPINNER(state, payload) {
		state.showVideoReviewSpinner = payload;
	}
};

const actions = {
	toggleExpandedMenu(context) {
		context.commit('TOGGLE_EXPANDED_MENU');
	},
	toggleExpandedSmallNav(context) {
		context.commit('TOGGLE_EXPANDED_SMALL_NAV');
	},
	closeExpandedSmallNav(context) {
		context.commit('CLOSE_EXPANDED_SMALL_NAV');
	},
	toggleExpandedSmallSearch(context) {
		context.commit('TOGGLE_EXPANDED_SMALL_SEARCH');
	},
	closeExpandedSmallSearch(context) {
		context.commit('CLOSE_EXPANDED_SMALL_SEARCH');
	},
	toggleExpandedProfileSelector(context) {
		context.commit('TOGGLE_EXPANDED_PROFILE_SELECTOR');
	},
	toggleBrandBuilderNav(context) {
		context.commit('TOGGLE_BRAND_BUILDER_NAV');
	},
	toggleBrandBuilder(context) {
		context.commit('TOGGLE_BRAND_BUILDER');
	},
	brandBuilderCreated(context) {
		context.commit('BRAND_BUILDER_CREATED');
	},
	brandBuilderDestroyed(context) {
		context.commit('BRAND_BUILDER_DESTROYED');
	},
	dashboardCreated(context) {
		context.commit('DASHBOARD_CREATED');
	},
	dashboardDestroyed(context) {
		context.commit('DASHBOARD_DESTROYED');
	},
	toggleDashboard(context) {
		context.commit('TOGGLE_DASHBOARD');
	},

	toggleFeedBackModal(context, data) {
		context.commit('TOGGLE_FEEDBACK_MODAL');
	},
	setVideoReviewSpinner(context, data) {
		context.commit('SET_VIDEO_REVIEW_SPINNER', data);
	}
};

export default {
	state,
	actions,
	mutations,
};
